/** Valeur saisie dans `vitrineContent.logements` (texte libre ou entier). */

export type VitrineUnitsCountParsed = {
  /** Texte affiché tel quel (ex. « 1 à 4 », « 24 »). */
  display?: string;
  /** Entier uniquement si la saisie est un nombre simple (filtres catalogue). */
  integerCount?: number;
};

export function coerceVitrineUnitsCountRaw(value: unknown): string {
  if (value == null) return '';
  return String(value).trim();
}

const UNITS_COUNT_RANGE_RE = /\d\s*[àaA\-–]\s*\d/;

export function parseVitrineUnitsCountField(value: unknown): VitrineUnitsCountParsed {
  const s = coerceVitrineUnitsCountRaw(value);
  if (!s) return {};

  if (UNITS_COUNT_RANGE_RE.test(s)) {
    return { display: s };
  }

  const compact = s.replace(/\s/g, '');
  if (/^\d+$/.test(compact)) {
    const n = parseInt(compact, 10);
    if (Number.isFinite(n)) {
      return { display: String(n), integerCount: n };
    }
  }

  if (/[^\d\s]/.test(s)) {
    return { display: s };
  }

  return { display: s };
}
